// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-callback-container {
  width: 100%;
  max-width: 576px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
  margin: 0 auto;
  min-height: calc(100vh - 80px);
}
.payment-callback-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.payment-callback-content .payment-callback-title {
  font-size: 18px;
  font-weight: 510;
  color: #8E7E54;
  margin: 24px 0 8px 0;
}
.payment-callback-content .payment-callback-subtitle {
  font-size: 13px;
  font-weight: 400;
  color: #595959;
  margin: 0;
  max-width: 340px;
  line-height: 1.4;
}
/*# sourceMappingURL=PaymentCallbackPage.css.map */`, "",{"version":3,"sources":["webpack://./PaymentCallbackPage.less","webpack://./src/containers/PaymentCallbackPage/PaymentCallbackPage.less"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,8BAAA;ACCD;ADEA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;ACAD;ADJA;EAOE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;ACAF;ADVA;EAcE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;ACDF;AACA,kDAAkD","sourcesContent":[".payment-callback-container {\n\twidth: 100%;\n\tmax-width: 576px;\n\tbackground-color: #ffffff;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 20px 16px;\n\tmargin: 0 auto;\n\tmin-height: calc(100vh - 80px);\n}\n\n.payment-callback-content {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\ttext-align: center;\n\n\t.payment-callback-title {\n\t\tfont-size: 18px;\n\t\tfont-weight: 510;\n\t\tcolor: #8E7E54;\n\t\tmargin: 24px 0 8px 0;\n\t}\n\n\t.payment-callback-subtitle {\n\t\tfont-size: 13px;\n\t\tfont-weight: 400;\n\t\tcolor: #595959;\n\t\tmargin: 0;\n\t\tmax-width: 340px;\n\t\tline-height: 1.4;\n\t}\n}\n",".payment-callback-container {\n  width: 100%;\n  max-width: 576px;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 16px;\n  margin: 0 auto;\n  min-height: calc(100vh - 80px);\n}\n.payment-callback-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n.payment-callback-content .payment-callback-title {\n  font-size: 18px;\n  font-weight: 510;\n  color: #8E7E54;\n  margin: 24px 0 8px 0;\n}\n.payment-callback-content .payment-callback-subtitle {\n  font-size: 13px;\n  font-weight: 400;\n  color: #595959;\n  margin: 0;\n  max-width: 340px;\n  line-height: 1.4;\n}\n/*# sourceMappingURL=PaymentCallbackPage.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
